module.exports = __webpack_public_path__ + "img/bell.15cf420e.svg";